import React, { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';

function Row({
  row, actions, active, getControlTP,
}) {
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        {getControlTP('year', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('bull', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('cow', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('heifer1_2', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('heifer2_ower', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('heifer_1', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('piggy9_ower', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('piggy4_ower', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('piggy_2', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('goat', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('sheep', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('horse3_ower', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('horse_1', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('rabbit', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('chikken', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('bee', row.id)}
      </TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    member: PropTypes.shape({ id: PropTypes.number, repr: PropTypes.string }),
    is_owner: PropTypes.bool,
  }).isRequired,
  fields: PropTypes.shape({
    member: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  active: PropTypes.bool,
  errors: PropTypes.shape({ member: PropTypes.arrayOf(PropTypes.string) }),
  getControlTP: PropTypes.func.isRequired,
};

Row.defaultProps = {
  active: false,
  errors: null,
};

export default memo(Row);
